module.exports = __webpack_public_path__ + "img/示例图_5-4.96f678ae.png";